/* Observe the native price so both Mono and the frame-picker app remain authoritative. */
if (!customElements.get('canvoil-price-estimate')) {
  customElements.define('canvoil-price-estimate', class extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('.canvoil-price-source');
      this.presentation = this.querySelector('.canvoil-price-presentation');
      this.prices = JSON.parse(this.querySelector('[data-estimate-prices]').textContent);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    update() {
      const native = this.source.querySelector('.price');
      const selector = native?.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale' : '.price__regular > .price-item--regular';
      const normalize = value => value.replace(/\s/g, '').trim();
      const current = normalize(native?.querySelector(selector)?.textContent || '');
      const match = this.prices.find(price => price.matches.some(value => normalize(value) === current));
      // Fall back to the real price if another app changes formatting or eligibility is uncertain.
      const usable = Boolean(match) && !native?.classList.contains('price--sold-out');
      this.classList.toggle('has-estimate', usable);
      this.presentation.hidden = !usable;
      if (!usable) return;
      this.querySelector('[data-before]').textContent = match.before;
      this.querySelector('[data-after]').textContent = match.after;
    }
  });
}
